import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/observable/of';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { catchError, tap } from 'rxjs/operators';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { Progress } from './progress.model';
import { CognitoService } from '../../services/cognito/cognito.service';
import { AwsSignerService } from '../../services/aws-signer/aws-signer.service';
import { Encoder } from '../../utils/encoder';
import { escape } from 'lodash';
import { REGIONS } from '../../services/constants/region-list';
import { PARTIES } from '../../services/constants/party-list';
import { COUNTRIES } from '../../services/constants/country-list';
import { BUS } from '../../services/constants/business-unit-list';
import { ProgressListResponse } from './progress-list-reponse.model';

@Injectable()
export class ProgressService {

  constructor(private http: HttpClient,
    private cognitoService: CognitoService,
    private awsSignerService: AwsSignerService) {
  }

  getErrorPackage() {
    return this.http.get('assets/errormsg-mapping.json');
  }

  getProgressList(nextPageKey): Observable<any> {
    let url = this.getUrl();
    if (nextPageKey) {
      const encodedNextPageKey = Encoder.encode(nextPageKey);
      url = url.concat('?nextPageKey=' + encodedNextPageKey);
    }

    const awsHeaders = this.awsSignerService.getAwsHeader(url, 'GET');
    const headerParams = {
      'Content-Type': 'application/json',
      'Authorization': awsHeaders['Authorization'],
      'X-Amz-Date': awsHeaders['X-Amz-Date'],
      'x-amz-security-token': awsHeaders['x-amz-security-token'],
      'x-api-key': environment.cesAPI.apiKey,
    };

    const httpOptions = {
      headers: new HttpHeaders(headerParams)
    };

    return this.http.get<ProgressListResponse>(url, httpOptions)
      .pipe(catchError(err => this.handleError(err)));
  }

  getAllProgressList(nextPageKey: string) {
    let url = this.getUrl() + '/archived';
    if (nextPageKey) {
      // const encodedNextPageKey = Encoder.encode(nextPageKey);
      // url = url.concat('?nextPageKey=' + encodedNextPageKey);
      url = url.concat('?nextPageKey=' + nextPageKey)
    }
    const awsHeaders = this.awsSignerService.getAwsHeader(url, 'GET');

    const headerParams = {
      'Content-Type': 'application/json',
      'Authorization': awsHeaders['Authorization'],
      'X-Amz-Date': awsHeaders['X-Amz-Date'],
      'x-amz-security-token': awsHeaders['x-amz-security-token'],
      'x-api-key': environment.cesAPI.apiKey,
    };


    const httpOptions = {
      headers: new HttpHeaders(headerParams)
    };

    return this.http.get<ProgressListResponse>(url, httpOptions)
      .pipe(catchError(err => this.handleError(err)));
    // return this.http.get("assets/falseData.json")
  }

  getProgressById(progressId): Observable<any> {
    //const encodedId = Encoder.encode(progressId);
    const awsHeaders = this.awsSignerService.getAwsHeader(`${this.getUrl()}/${progressId}`, 'GET');

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': awsHeaders['Authorization'],
        'X-Amz-Date': awsHeaders['X-Amz-Date'],
        'x-amz-security-token': awsHeaders['x-amz-security-token'],
        'x-api-key': environment.cesAPI.apiKey
      })
    };

    return this.http.get<Progress>(`${this.getUrl()}/${progressId}`, httpOptions)
      .pipe(catchError(err => this.handleError(err)));
  }

  getErrorFileLink(errPath) {
    let url = this.getUrl() + '/errorlink';

    // const jwtToken = this.cognitoService.getJwtToken();
    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     'Content-Type': 'application/json',
    //     'Authorization': jwtToken,
    //     'x-api-key': environment.cesAPI.apiKey
    //   })
    // };
    const awsHeaders = this.awsSignerService.getAwsHeader(url, 'POST', errPath);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': awsHeaders['Authorization'],
        'X-Amz-Date': awsHeaders['X-Amz-Date'],
        'x-amz-security-token': awsHeaders['x-amz-security-token'],
        'x-api-key': environment.cesAPI.apiKey
      })
    };


    return this.http.post(url, errPath, httpOptions).pipe(catchError(err => this.handleError(err)));
  }


  deleteFileByFileKey(progressId, filekey): Observable<any> {
    //const encodedId = Encoder.encode(progressId);
    const awsHeaders = this.awsSignerService.getAwsHeader(`${this.getUrl()}/${progressId}/${filekey}`, 'DELETE');

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': awsHeaders['Authorization'],
        'X-Amz-Date': awsHeaders['X-Amz-Date'],
        'x-amz-security-token': awsHeaders['x-amz-security-token'],
        'x-api-key': environment.cesAPI.apiKey
      })
    };

    return this.http.delete<Progress>(`${this.getUrl()}/${progressId}/${filekey}`, httpOptions)
      .pipe(catchError(err => this.handleError(err)));
  }

  private getUrl() {
    return `${localStorage.getItem('region-api')}/v1/datamart/batchstatus`;
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error && error.error.message === 'The security token included in the request is expired') {
      this.cognitoService.logout();
      return;
    }
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an ErrorObservable with a user-facing error message
    return new ErrorObservable(
      'Something bad happened. Please try again later.');
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/progress/progress.service.ts